import { AxiosError } from 'axios'
import { getTraceId } from 'errors/AxiosErrorUtils'

/**
 * Abstraction over logging so that we can automatically hook in extra functionality such as traceId logging for errors.
 */
export class Logger {
  static log(...args: any[]) {
    this.logForType('log', ...args)
  }

  static info(...args: any[]) {
    this.logForType('info', ...args)
  }

  static error(...args: any[]) {
    this.logForType('error', ...args)
    this.logTraceId(...args)
  }

  static warn(...args: any[]) {
    this.logForType('warn', ...args)
  }

  static logForType(type: 'log' | 'info' | 'error' | 'warn', ...args: any[]) {
    console[type](...args)
  }

  static logTraceId(...args: any[]) {
    const axiosError: AxiosError | undefined = args.find((arg) => arg?.isAxiosError)
    if (axiosError) {
      this.logForType('error', 'traceId:', getTraceId(axiosError))
    }
  }
}
